<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em !important;">Pauline Palmer is a native of Birmingham and has lived in South Pembrokeshire for thirty years.</p><br/>
<p style="text-indent:0em !important;">Her interest in Charlemagne began in the 1980s following a visit to Aachen Cathedral.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4b5f298c